'use client';

import RawHtml from '@components/RawHtml';
import clsx from 'clsx';
import { useRef, useState } from 'react';

type Props = { value: string; cssClass?: string; stick_to_prev?: boolean };

function TruncatedRichtext(props: Props) {
  const { value, cssClass, stick_to_prev } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [extended, setExtended] = useState(false);

  return (
    <>
      <RawHtml html={value} className={clsx('truncated', cssClass, { 'reduced-margin': stick_to_prev })} ref={ref} />
      <button
        className='truncated__button button button--ghost button--white'
        onClick={() => {
          ref.current?.classList.toggle('truncated--extended', !extended);
          setExtended(!extended);
        }}
      >
        {extended ? 'Weniger anzeigen' : 'Weiterlesen'}
      </button>
    </>
  );
}

export default TruncatedRichtext;
